import Swiper from "swiper";
import "swiper/css";

export default class TestimonialsSlider extends HTMLElement {
    swiperEl;
    sliderBreakpoint = window.matchMedia("screen and (max-width: 767px)");
    swiper;

    constructor(...args) {
        const self = super(...args);
        self.init();
        return self;
    }

    init() {}

    connectedCallback() {
        this.resolveElements();
        this.registerEvents();
        this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1,
          spaceBetween: 16,
        //   slidesOffsetBefore: 16,
        //   slidesOffsetAfter: 16,
          on: {
            init: (swiper) => {
              this.sliderBreakpoint.matches ? swiper.enable() : swiper.disable();
            },
          },
          breakpoints: {
            560: {
              spaceBetween: 16,
              slidesPerView: 1.25,
            },
            768: {
              spaceBetween: 24,
              slidesPerView: 2.25,
            },
            1024: {
              spaceBetween: 32,
              slidesPerView: 3,
            }
          }
        });
      }

    resolveElements() {
        this.swiperEl = this.querySelector(".swiper");
    }

    registerEvents() {
        this.sliderBreakpoint.onchange = (mq) => {
            if (mq.matches) {
              this.swiper.enable();
            } else {
              this.swiper.slideTo(0);
              this.swiper.disable();
            }
        }
    }
}
